import { Component, Injector, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { FormGroup, FormControl, FormArray } from '@angular/forms';
import { CustomDetailComponent, SharedModule, ProductVariant } from '@vendure/admin-ui/core';
import { ProductVariantDetailComponent } from '@vendure/admin-ui/catalog';

@Component({
    template: `
        <vdr-card title="Store Visibility" style="padding-bottom: 2%">
            <vdr-form-field for="visibility">
                <clr-toggle-wrapper *vdrIfPermissions="['UpdateCatalog', 'UpdateProduct']">
                    <input type="checkbox" clrToggle name="enabled" [formControl]="theEnabled" />
                    <label>{{ 'common.enabled' | translate }}</label>
                </clr-toggle-wrapper>
            </vdr-form-field>
        </vdr-card>
    `,
    standalone: true,
    imports: [SharedModule],
})
export class ProductVariantEnabilityFormComponent implements CustomDetailComponent, OnInit {
    entity$: Observable<ProductVariant>;
    detailForm: FormGroup;
    pricesForm: FormArray;
    theEnabled = new FormControl(false);

    extraInfo$: Observable<any>;

    constructor(private injector: Injector) {}

    ngOnInit() {
        const parentComponent = this.injector.get(ProductVariantDetailComponent);
        if (parentComponent) {
            this.pricesForm = parentComponent.pricesForm;
        }

        this.entity$.subscribe(entity => {
            const enabledValue = entity.prices?.[0]?.customFields?.enableVariant || false;
            this.theEnabled.setValue(enabledValue);
        });

        this.theEnabled.valueChanges.subscribe(newValue => {
            // ✅ Update all enableVariant values
            const updatedPrices = this.pricesForm.value.map(price => ({
                ...price,
                customFields: {
                    ...price.customFields,
                    enableVariant: newValue,
                },
            }));

            this.pricesForm.controls.forEach((control, index) => {
                control.get('customFields')?.setValue(updatedPrices[index].customFields);
                control.markAsDirty(); // Mark this individual control as dirty
            });
        });
    }
}
